import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface LostItemDetailTabInfo {
  lostItemCode?: string;
  storageLocationName?: string | null;
  description?: string;
  guestName?: string;
  foundAt?: string | null;
  quantity?: number;
  status?: string;
}

export interface LostItemDetailTab {
  id: number;
  info?: LostItemDetailTabInfo;
}

interface LostItemDetailState {
  tabs: LostItemDetailTab[];
  activeTabId: number | null;
}

const initialState: LostItemDetailState = { tabs: [], activeTabId: null };

const lostItemDetailSlice = createSlice({
  name: 'lostItemDetail',
  initialState,
  reducers: {
    addLostItemTab: (state, action: PayloadAction<LostItemDetailTab>) => {
      const existing = state.tabs.find(tab => tab.id === action.payload.id);
      if (existing) {
        existing.info = action.payload.info ?? existing.info;
      } else {
        state.tabs.push(action.payload);
      }
      state.activeTabId = action.payload.id;
    },
    removeLostItemTab: (state, action: PayloadAction<number>) => {
      state.tabs = state.tabs.filter(tab => tab.id !== action.payload);
      if (state.activeTabId === action.payload) {
        state.activeTabId = state.tabs[0]?.id ?? null;
      }
    },
    removeAllLostItemTabs: state => {
      state.tabs = [];
      state.activeTabId = null;
    },
    setActiveLostItemTab: (state, action: PayloadAction<number>) => {
      if (state.tabs.some(tab => tab.id === action.payload)) {
        state.activeTabId = action.payload;
      }
    },
    updateLostItemTabInfo: (
      state,
      action: PayloadAction<{ id: number; info: LostItemDetailTabInfo }>,
    ) => {
      const tab = state.tabs.find(item => item.id === action.payload.id);
      if (tab) tab.info = action.payload.info;
    },
  },
});

export const {
  addLostItemTab,
  removeLostItemTab,
  removeAllLostItemTabs,
  setActiveLostItemTab,
  updateLostItemTabInfo,
} = lostItemDetailSlice.actions;

export const lostItemDetailTabsSelector = (state: { lostItemDetail: LostItemDetailState }) =>
  state.lostItemDetail.tabs;
export const activeLostItemTabSelector = (state: { lostItemDetail: LostItemDetailState }) =>
  state.lostItemDetail.tabs.find(tab => tab.id === state.lostItemDetail.activeTabId)?.id ?? null;

export default lostItemDetailSlice.reducer;
